import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

export const QuoteContainer = styled(Stack)`
  &.sm-text-align-center {
    ${mediaQuery(
      'sm',
      css`
        .quote {
          text-align: center;
        }
        .sub-quote {
          text-align: center;
        }
      `
    )}
  }
`;
